require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-violent-crime.json") })
        }
      }, "path---tags-violent-crime");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-violent-crime!./.cache/json/tags-violent-crime.json
// module id = 1053
// module chunks = 231608221292675